import classNames from 'classnames';

interface FilterButtonProps {
  label: string;
  isActive: boolean;
  onClick: () => void;
}

export function FilterButton({ label, isActive, onClick }: FilterButtonProps) {
  return (
    <button
      className={classNames(
        isActive
          ? '!bg-brand-primary !text-black'
          : 'bg-surface-elevated/40 text-secondary/70 hover:bg-surface-elevated hover:text-white/80',
        'flex-shrink-0 group flex gap-x-3 rounded-md p-2 pl-3 text-sm leading-6 font-medium hover:bg-brand-primaryDark justify-between',
        'transition ease-in-out duration-150 items-center',
      )}
      onClick={onClick}
    >
      {label}
    </button>
  );
}
